import { API, graphqlOperation } from "aws-amplify";
import { ISaleCustomerStatRepository } from "./saleCustomerStat.types";
import * as queries from "@/graphql/queries";
import { Stat } from "@/entities";
import dayjs from "dayjs";

export class SaleCustomerStatAPIRepository
    implements ISaleCustomerStatRepository
{
    async getSaleCustomerStat(
        id: string,
        granularity: string,
        timestamp: number
    ): Promise<Stat> {
        const result = (await API.graphql({
            ...graphqlOperation(queries.getSaleCustomerStat, {
                id,
                granularity,
                timestamp,
                // nextToken,
                // limit: 1,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        console.log(result.data.getSaleCustomerStat);
        return new Stat(result.data.getSaleCustomerStat);
    }

    async listSaleCustomerStatBySaleID(
        saleID: string,
        granularity: string,
        timestamp: number
    ): Promise<any> {
        const result = (await API.graphql({
            ...graphqlOperation(
                queries.saleCustomerStatBySaleIDAndGranularityAndTimestamp,
                {
                    saleID,
                    granularity,
                    timestamp,
                }
            ),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        return result.data.saleCustomerStatBySaleIDAndGranularityAndTimestamp.items.map(
            (item: any) => new Stat(item)
        );
    }

    // async refreshDailyStat(): Promise<void> {
    //     const result = await API.post("saletoolapi","/stat/branch/daily", {
    //         body: {
    //             date: dayjs().format("YYYY-MM-DD")
    //         }
    //     })
    //     console.log({result})
    //     return;
    // }
}
